import { createNavigation } from 'next-intl/navigation'

import { routing } from './routing'

// Locale-aware navigation helpers. `Link`/`redirect`/`getPathname` automatically
// add the locale prefix for non-default locales (`localePrefix: 'as-needed'`),
// so components link with bare paths like `/` and `/thank-you`.
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing)
